import {Actions, createEffect, ofType} from "@ngrx/effects";
import {ApiService} from "../../service/api.service";
import {
  deliveryProof,
  deliveryProofSuccess,
  failure,
  getOrderDetailsData,
  getOrderDetailsDataSucess,
  getOrderTrackInfoConfig,
  getOrderTrackInfoConfigSucess,
  loadCarrierData,
  loadCarrierDataSuccess,
  loadDeliveryDataFailure,
  loadDeliveryDetails,
  loadDeliveryDetailsAndFeatureVisibilitySuccess,
  loadDeliveryDetailsSuccess,
  loadEta,
  loadEtaSuccess,
  loadOrderStatus,
  loadOrderStatusSuccess,
  loadOrderTrackById,
  loadOrderTrackByIdSuccess,
  loadRatings,
  loadRatingsSuccess,
  loadTrackDetails,
  loadTrackDetailsSuccess,
  postRatings,
  postRatingSuccess,
  setAccountLogoForOrderId,
  setAccountLogoForOrderIdSuccess,
  setDeliverTokenId,
  setOrderStatusForTimeline,
  setSelfAccountLogo
} from "./home.action";
import {catchError, forkJoin, from, map, of, switchMap, withLatestFrom} from "rxjs";
import {Injectable} from "@angular/core";
import {AppState} from "src/app/state/app.state";
import {Store} from "@ngrx/store";
import {deliveryDetailsSelector} from "src/app/state/home/home.selector";

@Injectable()
export class HomeEffects {
  loadOrderStatus$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadOrderStatus),
      switchMap(_ =>
        this.apiService.getOderStatus().pipe(
          withLatestFrom(this.store.select(deliveryDetailsSelector)),
          switchMap(([res, od]) => {
            const actions = new Array<any>();
            if (!res?.isActive) {
              actions.push(loadOrderStatusSuccess({data: res}));
            } else {
              actions.push(loadOrderStatusSuccess({data: res}), loadEta(), loadCarrierData())
            }

            if (od) {
              actions.push(loadDeliveryDetailsSuccess({deliveryDetails: od}));
            }
            return actions;
          }),
          catchError(error => of(loadDeliveryDataFailure({ error })))
        )
      )
    );
  });

  // Fetches delivery details and feature-visibility flags in parallel,
  // replacing the old two-step sequential chain (loadDeliveryDetails$ → loadDeliveryDetailsAndFeatureVisibility$).
  loadDeliveryDetailsAndFeatureVisibility$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadDeliveryDetails),
      switchMap(() =>
        forkJoin({
          deliveryDetails: this.apiService.getDeliveryDetails(),
          featureVisibility: this.apiService.getFeatureVisbilityProperties(),
        }).pipe(
          map(({ deliveryDetails, featureVisibility }) =>
            loadDeliveryDetailsAndFeatureVisibilitySuccess({ deliveryDetails, featureVisibility })
          ),
          catchError(error => of(loadDeliveryDataFailure({ error })))
        )
      )
    );
  });

  // Fetches the orderId-based tracking payload (different shape from deliveryTokenId).
  // The interceptor appends ?orderId= automatically. Also resolves the account logo.
  loadOrderTrackById$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadOrderTrackById),
      switchMap(() =>
        this.apiService.getOrderTrackById().pipe(
          switchMap(data => [
            loadOrderTrackByIdSuccess({ data }),
            setOrderStatusForTimeline({ value: data.order?.orderStatus ?? '' }),
            setSelfAccountLogo(),
          ]),
          catchError(error => of(loadDeliveryDataFailure({ error })))
        )
      )
    );
  });

  loadTrackDetails$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadTrackDetails),
      switchMap(() =>
        this.apiService.getTrackDetails().pipe(
          map(res => loadTrackDetailsSuccess({ data: res })),
          catchError(error => of(failure(error)))
        )
      )
    );
  });

  loadCarrierData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadCarrierData),
      switchMap(() =>
        this.apiService.getCarrierData().pipe(
          map(res => loadCarrierDataSuccess({ data: res })),
          catchError(err => of(failure(err)))
        )
      )
    );
  });

  loadEta$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadEta),
      switchMap(() =>
        this.apiService.getEta().pipe(
          map(res => loadEtaSuccess({ data: res })),
          catchError(error => of(failure(error)))
        )
      )
    );
  });

  constructor(private actions$: Actions, private apiService: ApiService, private store: Store<AppState>) {
  }

  loadRatings$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(loadRatings),
        switchMap((() =>
            from(this.apiService.getRatings()).pipe(
              map((res) => loadRatingsSuccess({data: res})),
              catchError((error) => of(failure(error)))
            )
        ))
      );
    }
  );


  postRatings$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(postRatings),
        switchMap(((action) =>
            from(this.apiService.postRatings(action.payload)).pipe(
              map((res) => postRatingSuccess({data: res})),
              catchError((error) => of(failure(error)))
            )
        ))
      );
    }
  );


  deliveryProof$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(deliveryProof),
      switchMap(((action) =>
          from(this.apiService.postDeliveryConfirmation(action.payload, action.deliveryStatus, action.deliveryTokenId)).pipe(
            switchMap((res: { msg: string }) => {
              return [
                loadDeliveryDetails(),
                loadTrackDetails(),
                loadEta(),
                (loadRatings()),
                deliveryProofSuccess({msg: res['msg']}),

              ]
            }),
            catchError((error) => of(failure(error)))
          )
      ))
    );
  })

  // getOrderTrackInfoConfig$ =createEffect(() => {
  //   return this.actions$.pipe(
  //     ofType(getOrderTrackInfoConfig),
  //     switchMap(((action) =>
  //       from(this.apiService.getOrderTrackInfoConfig()).pipe(
  //         map((res) => getOrderTrackInfoConfigSucess({data: res})),
  //         catchError((error) => of(failure(error)))
  //       )
  //   ))
  //   );
  // })

  getOrderDetailsData$ =createEffect(() => {
    return this.actions$.pipe(
      ofType(getOrderDetailsData),
      switchMap(((action) =>
        from(this.apiService.getOrderDeatilsData()).pipe(
          switchMap((res) => {
            return [getOrderDetailsDataSucess({res:res})]
          }),
          catchError((error) => of(failure(error)))
        )
    ))
    );
  })

  setAccountLogoForOrderId$ =createEffect(() => {
    return this.actions$.pipe(
      ofType(setAccountLogoForOrderId),
      switchMap(((action) =>
        from(this.apiService.getAccountLogo(action.orderId,action.accountId)).pipe(
          map((res) => setAccountLogoForOrderIdSuccess({logo:res})),
          catchError((error) => of(failure(error)))
        )
    ))
    );
  })

  setSelfAccountLogo$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(setDeliverTokenId, setSelfAccountLogo),
      switchMap(() =>
        this.apiService.getSelfAccountLogo().pipe(
          map((res) => setAccountLogoForOrderIdSuccess({logo: res})),
          catchError(() => of(setAccountLogoForOrderIdSuccess({logo: null})))
        )
      )
    );
  })


}
